import Settori from "./Settori";
export default Settori;
